export const GREEN_FLAG_ICON_IMAGE_ID = 'rt-green-flag-icon';

const _ICON_SIZE_PX = 32;

// A green pennant flag on a thin pole ("ножка"). The pole is centred
// horizontally so the symbol layer can anchor it at `bottom` — the base
// of the pole then sits exactly on the waypoint coordinate. Green matches
// the app's primary token (#389e0d); the dark rim lifts it off the
// basemap and the white pole highlight keeps it readable on dark tiles.
const _FLAG_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="${_ICON_SIZE_PX}" height="${_ICON_SIZE_PX}" viewBox="0 0 32 32">
  <rect x="14.6" y="2.5" width="2.2" height="28.5" rx="1.1" fill="#3a3a3a"/>
  <rect x="15.1" y="3" width="0.7" height="27.5" fill="#ffffff" fill-opacity="0.55"/>
  <path d="M16.8 3 L30 7.4 L16.8 11.8 Z"
        fill="#389e0d" stroke="#1f5e08" stroke-width="0.9" stroke-linejoin="round"/>
</svg>
`.trim();

export function buildGreenFlagIconDataUrl(): string {
  const encoded = encodeURIComponent(_FLAG_SVG);
  return `data:image/svg+xml;charset=utf-8,${encoded}`;
}

export function loadGreenFlagIconImage(): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image(_ICON_SIZE_PX, _ICON_SIZE_PX);
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('failed to load green flag icon'));
    img.src = buildGreenFlagIconDataUrl();
  });
}
